import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { PENDING, IDLE } from "const"
import { CcLibraryHeading, CcLibraryHeadingCreate } from "server/models"
import {
    useInput,
    StateType,
} from "client/utils"
import {
    StoreType,
    CcLibraryHeadingValidation,
    SaveCcLibraryHeading,
    SearchCcLibraryHeadings,

    closeModal,
    setCcLibraryHeadingEdit,
    setCcLibraryHeadingReloadEdit,
    setCcLibraryItemReloadList,
    setCcLibraryHeadingAvailableParentsFiltered,
    setCcLibraryHeadingAvailableParentSearch,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Input,
    SelectDropdown,
    SelectDropdownItem,
    SelectDropdownSearch,
    Feedback,
    Button,
    SpinnerIcon,
    Empty,
} from "client/components"

interface EditHeadingProps {
    heading: CcLibraryHeading
    parent: CcLibraryHeading
}

let isMounted: boolean

const Form = ({
    heading,
    parent,
}: EditHeadingProps) => {
    const set = useSelector((state: StoreType) => state.ccLibrarySet.setView)
    const headingList = useSelector((state: StoreType) => state.ccLibraryHeading.headingList)
    const parentHeadings = useSelector((state: StoreType) => state.ccLibraryHeading.availableParents)
    const parentHeadingsFiltered = useSelector((state: StoreType) => state.ccLibraryHeading.availableParentsFiltered)
    const parentHeadingSearch = useSelector((state: StoreType) => state.ccLibraryHeading.availableParentSearch)

    const modals = useSelector((state: StoreType) => state.system.modals)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [title, setTitle] = useInput(heading.title)
    const [parentHeading, setParentHeading] = useState<CcLibraryHeading>(heading.id ? headingList[heading.headingId] : parent)
    const [validation, setValidation] = useState<CcLibraryHeadingValidation>(null)

    const [saveState, setSaveState] = useState<StateType>(IDLE)
    const [applyState, setApplyState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    useEffect(() => {
        const filtered = SearchCcLibraryHeadings(parentHeadings, parentHeadingSearch)
        dispatch(setCcLibraryHeadingAvailableParentsFiltered(filtered))
    }, [parentHeadings, parentHeadingSearch])

    const onClose = () => {
        if (!isMounted) return
        if (modals.length) {
            if (isMounted) dispatch(closeModal())
        }
    }

    const onSave = (mode: number) => {
        if (mode === 1) setSaveState(PENDING)
        if (mode === 2) setApplyState(PENDING)

        const newHeadingId = parentHeading ? parentHeading.id : null

        // new heading data
        const newHeadingData: CcLibraryHeadingCreate = {
            headingId: newHeadingId,
            librarySetId: set.id,
            title,
            order: heading.id && heading.headingId === newHeadingId ? heading.order : null,
        }

        SaveCcLibraryHeading(
            heading.id,
            newHeadingData,
            lang,
        ).then((res) => {
            if (isMounted) {
                setValidation(res.validation)
                setSaveState(IDLE)
                setApplyState(IDLE)
            }
            if (res.validation) return

            dispatch(setCcLibraryHeadingEdit({
                ...newHeadingData,
                id: res.newHeadingId || heading.id,
                order: res.newOrder,
            }))

            dispatch(setCcLibraryItemReloadList(false))
            setTimeout(() => {
                dispatch(setCcLibraryItemReloadList(true))
            }, 0)

            if (mode === 1) onClose()
            if (mode === 2) {
                dispatch(setCcLibraryHeadingReloadEdit(false))
                setTimeout(() => {
                    dispatch(setCcLibraryHeadingReloadEdit(true))
                }, 0)
            }
        })
    }

    return (
        <PageForm>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.title}</Label>
                        <Input type="text" value={title} onChange={setTitle} />
                        <Feedback>{validation && validation.title}</Feedback>
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.parentParagraph}</Label>
                        <SelectDropdown title={parentHeading ? parentHeading.title : <Empty />}>
                            <SelectDropdownSearch
                                value={parentHeadingSearch}
                                onChange={(e) => dispatch(setCcLibraryHeadingAvailableParentSearch(e.target.value))}
                                onClearSearch={() => dispatch(setCcLibraryHeadingAvailableParentSearch(""))}
                            />
                            <SelectDropdownItem onClick={() => setParentHeading(null)}>
                                <Empty />
                            </SelectDropdownItem>
                            {
                                parentHeadingsFiltered.map((row) => (
                                    <SelectDropdownItem
                                        key={row.id}
                                        onClick={() => setParentHeading(row)}
                                    >
                                        {row.title}
                                    </SelectDropdownItem>
                                ))
                            }
                        </SelectDropdown>
                    </FormGroup>
                </Col>

                <Col xs={12}>
                    <Button variant="success" row onClick={() => onSave(1)}>
                        {saveState === PENDING ? <SpinnerIcon /> : lang.save}
                    </Button>
                    <Button variant="success" row onClick={() => onSave(2)}>
                        {applyState === PENDING ? <SpinnerIcon /> : lang.apply}
                    </Button>
                    <Button row onClick={onClose}>{lang.cancel}</Button>
                </Col>
            </Row>
        </PageForm>
    )
}
export default Form
